"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferRatingCategoryType = exports.AccountRatingCategoryType = exports.RatingType = void 0;
var RatingType;
(function (RatingType) {
    RatingType["Account"] = "account";
    RatingType["Offer"] = "offer";
    RatingType["Unrecognized"] = "unrecognized";
})(RatingType || (exports.RatingType = RatingType = {}));
var AccountRatingCategoryType;
(function (AccountRatingCategoryType) {
    AccountRatingCategoryType["Puntuality"] = "puntuality";
    AccountRatingCategoryType["Hygiene"] = "hygiene";
    AccountRatingCategoryType["Overall"] = "overall";
})(AccountRatingCategoryType || (exports.AccountRatingCategoryType = AccountRatingCategoryType = {}));
var OfferRatingCategoryType;
(function (OfferRatingCategoryType) {
    OfferRatingCategoryType["Taste"] = "taste";
    OfferRatingCategoryType["Quality"] = "quality";
    OfferRatingCategoryType["Hygiene"] = "hygiene";
    OfferRatingCategoryType["Overall"] = "overall";
})(OfferRatingCategoryType || (exports.OfferRatingCategoryType = OfferRatingCategoryType = {}));
